let popupLinks = document.querySelectorAll('.popup-link');
let popupWraps = document.querySelectorAll('.landing-popup-wrapper');
let reviewPopup = document.querySelector('.review-popup');
let popupToOpen = '';
let openedPopup = '';
let overPopup = '';
let closePopup = '';

popupLinks.forEach(el => el.addEventListener('click', function () {
    popupToOpen = el.getAttribute('data-popup-open-id');
    if (el.classList.contains('wc_product_review_badge')) {
        reviewPopup.style.display = 'block';
        reviewPopup.classList.add('opened-popup');
        document.querySelector('html').style.overflowY = 'hidden';
        overPopup = reviewPopup.querySelector('.landing-popup-overlay');
        closePopup = reviewPopup.querySelector('.landing-popup-close');
        addEventForPopup();
    }
    else {
        popupWraps.forEach(pw => {
            if(pw.getAttribute('data-popup-id') == popupToOpen) {
                overPopup = pw.querySelector('.landing-popup-overlay');
                closePopup = pw.querySelector('.landing-popup-close');
                if(pw.classList.contains('landing-product-popup-hide')) {
                    pw.classList.remove('landing-product-popup-hide');
                    pw.classList.add('landing-product-popup-show');
                    closePopup = pw.querySelector('.landing-product-popup-close');
                    document.querySelector('#main').classList.add('main-fixed');
                    document.querySelector('.section--logo-slider').style.top = document.querySelector('.hero-wrapper').clientHeight + 'px';
                    document.querySelector('.section--logo-slider').nextSibling.style.top = document.querySelector('.hero-wrapper').clientHeight + document.querySelector('.section--logo-slider').clientHeight + 'px';
                }
                else pw.style.display = 'block';
                pw.classList.add('opened-popup');
                if(document.querySelector('.landing-popup-tandi .landing-popup-text')) {
                    if(document.documentElement.clientWidth < 814) {
                        document.querySelector('.landing-popup-tandi .landing-popup-text__wrapper').style.position = 'static';
                        document.querySelector('.landing-popup-tandi .landing-popup-close').style.display = 'flex';
                    }
                    if(document.querySelector('.landing-popup-tandi .landing-popup-text').scrollHeight > document.querySelector('.landing-popup-tandi .landing-popup-text').clientHeight) {
                        document.querySelector('.landing-popup-tandi .landing-popup-text').style.justifyContent = 'flex-start';
                        document.querySelector('.landing-popup-tandi .landing-popup-text').style.position = 'relative';
                        if(document.documentElement.clientWidth >= 814) {
                            document.querySelector('.landing-popup-tandi .landing-popup-text').style.top = '48px';
                        };
                    };
                }
                document.querySelector('html').style.overflowY = 'hidden';
                
                addEventForPopup();
            }
        })
    }
})
)

function addEventForPopup() {
if (overPopup) {
    overPopup.addEventListener('click', function () {
        openedPopup = document.querySelector('.opened-popup');
        if(openedPopup.classList.contains('landing-product-popup-show')) {
            openedPopup.classList.add('landing-product-popup-hide');
            openedPopup.classList.remove('landing-product-popup-show');
            document.querySelector('#main').classList.remove('main-fixed');
            
        }
        else openedPopup.style.display = 'none';
        document.querySelector('html').style.overflowY = 'auto';
        openedPopup.classList.remove('opened-popup');
    });
}

if (closePopup) {
    closePopup.addEventListener('click', function () {
        openedPopup = document.querySelector('.opened-popup');
        if(openedPopup.classList.contains('landing-product-popup-show')) {
            openedPopup.classList.add('landing-product-popup-hide');
            openedPopup.classList.remove('landing-product-popup-show');
            document.querySelector('#main').classList.remove('main-fixed');
        }
        else openedPopup.style.display = 'none';
        document.querySelector('html').style.overflowY = 'auto';
        openedPopup.classList.remove('opened-popup');
    });
}
}